import {
  BasicButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  GhostButton,
  Modal,
  PrimaryButton,
  SecondaryTopNavWithStepper,
  Text,
} from "@certn/cascadia-react";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface Props {
  currentStep: number;
  buttonLabel: string;
  onComplete: () => void;
  onBack: () => void;
  isDisabled?: boolean;
  submitting?: boolean;
  confirmCancel: boolean;
}

export function SuccessFactorsIntegrationStepHeader({
  currentStep,
  buttonLabel,
  onComplete,
  onBack,
  isDisabled,
  submitting,
  confirmCancel,
}: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isCancelModalVisible, setCancelModalVisible] = useState(false);

  const steps = [
    t("Connect SAP"),
    t("Inbound webhook"),
    t("Packages and teams"),
  ];

  const leaveSetup = () => {
    navigate("/settings/ats-integrations");
  };

  const cancel = () => {
    if (confirmCancel) {
      setCancelModalVisible(true);
      return;
    }
    leaveSetup();
  };

  return (
    <>
      <SecondaryTopNavWithStepper
        testID="successfactors-setup-top-nav"
        stepperSteps={steps.map((title, index) => ({
          title,
          status: index < currentStep ? "COMPLETE" : "INCOMPLETE",
        }))}
        currentStepIndex={currentStep}
        handleClose={cancel}
        handlePrevStep={onBack}
      >
        {currentStep > 0 && (
          <GhostButton
            onPress={cancel}
            testID="successfactors-setup-top-nav-cancel-button"
          >
            {t("Cancel")}
          </GhostButton>
        )}
        <PrimaryButton
          onPress={onComplete}
          isDisabled={isDisabled}
          isLoading={submitting}
          testID="successfactors-setup-top-nav-next-button"
        >
          {buttonLabel}
        </PrimaryButton>
      </SecondaryTopNavWithStepper>
      <Modal isOpen={isCancelModalVisible}>
        <Dialog width="560px">
          <DialogHeader onClose={() => setCancelModalVisible(false)}>
            {t("Cancel integration")}
          </DialogHeader>
          <DialogContent>
            <Text style="form/body-primary">
              <Trans>
                You are about to leave the integration process. Any information
                you have entered so far will be lost.
              </Trans>
            </Text>
          </DialogContent>
          <DialogFooter>
            <BasicButton onPress={() => setCancelModalVisible(false)}>
              {t("Go back")}
            </BasicButton>
            <PrimaryButton
              onPress={leaveSetup}
              testID="cancel-integration-confirm-button"
            >
              {t("Cancel integration")}
            </PrimaryButton>
          </DialogFooter>
        </Dialog>
      </Modal>
    </>
  );
}
